import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  fetchPropertyList,
  updateUnit,
  createUnit,
  totalUnitList,
  unitData,
  fetchUnitDetails,
  fetchPropertyDetails
} from "@/services/unit";

@Module({
  namespaced: true,
})
export default class Unit extends VuexModule {
  //state
  //action
  
  @Action
  public async fetchPropertyDetails(id: any) {
    try {
      const data = await fetchPropertyDetails(id);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async fetchPropertyList(id: any) {
    try {
      const data = await fetchPropertyList(id);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async unitData(id: any) {
    try {
      const data = await unitData(id);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async updateUnit(payload) {
    try {
      const data = await updateUnit(payload);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async createUnit(payload) {
    try {
      const data = await createUnit(payload);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async totalUnitList(id:any) {
    try {
      const data = await totalUnitList(id);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async fetchUnitDetails(payload) {
    try {
      const data = await fetchUnitDetails(payload);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }

  //mutation
  //getters
}
